import {EditProfilesBloggerFormField} from "../types/edit-profiles-blogger-modal.types";

export const editProfilesBloggerModalName = 'edit-profiles-blogger';

export const editProfilesBloggerFormFields: Array<EditProfilesBloggerFormField> = [
  {
    label: 'Выберите ссылку',
    fieldName: 'id',
    type: 'select'
  },
  {
    label: 'Ссылка на профиль',
    fieldName: 'url',
    type: 'text'
  },
];
